import clsx from 'clsx';
import { memo } from 'react';

import type { ResizableLayoutProps } from './types';

import { ResizeIndicator } from './subcomponents/ResizeIndicator';
import { useResizableLayout } from './useResizableLayout';
import './ResizableLayout.css';

export const ResizableLayout = memo(
  ({
    children,
    defaultHeight = 'auto',
    defaultWidth = 'auto',
    direction,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    onResize,
    __private,
  }: ResizableLayoutProps) => {
    const sizeToContent = __private?.sizeToContent === true;
    const content = useResizableLayout({
      children,
      defaultHeight:
        sizeToContent && typeof defaultHeight !== 'number'
          ? undefined
          : defaultHeight,
      defaultWidth:
        sizeToContent && typeof defaultWidth !== 'number'
          ? undefined
          : defaultWidth,
      direction,
      maxHeight: sizeToContent ? maxHeight : (maxHeight ?? 'available'),
      maxWidth: sizeToContent ? maxWidth : (maxWidth ?? 'available'),
      minHeight,
      minWidth,
      onResize,
      __private,
    });
    const indicator = (
      <ResizeIndicator
        {...content.indicatorProps}
        label={__private?.label}
        __private={{
          hideIndicator: __private?.hideIndicator,
        }}
      />
    );

    return (
      <>
        <div
          className={content.containerClassName}
          ref={content.containerRef}
          style={content.containerStyle}
        >
          {direction === 'right' ? null : indicator}
          <div className="eds-resizable-layout--content">{children}</div>
          {direction === 'right' ? indicator : null}
        </div>
        {content.isDragging && (
          <div
            className={clsx('eds-resizable-layout--overlay', {
              'eds-resizable-layout--overlay--top': direction === 'top',
            })}
          />
        )}
      </>
    );
  },
);

ResizableLayout.displayName = 'ResizableLayout';
